import { useEffect, useState } from "react";
import { ref, onValue, off, get, query, orderByChild, equalTo } from "firebase/database";
import { database } from "../constants/firebase";
import { useUser } from "../contexts/UserContext";

const useUnreadMessages = () => {
    const { currentUser } = useUser();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!currentUser?.uid) return;

        const uid = currentUser.uid;

        let privateUnread = 0;
        let groupUnread = 0;
        const joinedGroups = [];

        let privateRef;
        let groupRef;


        const init = async () => {
            /* ───────── PRIVATE CHATS ───────── */
            privateRef = ref(database, "privateChats");

            onValue(privateRef, snapshot => {
                privateUnread = 0;

                if (snapshot.exists()) {
                    snapshot.forEach(chatSnap => {
                        const chatId = chatSnap.key;
                        const [userA, userB] = chatId.split("_");

                        // ✅ ONLY USER CHATS
                        if (uid !== userA && uid !== userB) return;

                        chatSnap.forEach(msgSnap => {
                            const msg = msgSnap.val();
                            if (msg.senderId !== uid && msg.seen !== true) {
                                privateUnread++;
                            }
                        });
                    });
                }

                setUnreadCount(privateUnread + groupUnread);
            });

            /* ───────── USER GROUPS ───────── */

            const groupsRef = ref(database, "Groups");

            const unsubscribe = onValue(groupsRef, snapshot => {
                if (!snapshot.exists()) return;


                snapshot.forEach(groupSnap => {
                    const group = groupSnap.val();
                    const groupId = groupSnap.key;

                    const isHost = group.hostId === uid;
                    const isMember = group.members?.[uid];

                    if (isHost || isMember) {
                        joinedGroups.push(groupId);
                    }
                });

            });

            const groupChatsRef = ref(database, "groupChats");

            onValue(groupChatsRef, snapshot => {
                groupUnread = 0;
                if (snapshot.exists()) {
                    snapshot.forEach(groupSnap => {
                        const groupId = groupSnap.key;

                        if (!joinedGroups.includes(groupId)) return;

                        groupSnap.forEach(msgSnap => {
                            const msg = msgSnap.val();
                            // ❌ Skip messages not visible to user
                            if (msg.deletedFor?.[currentUser.uid]) return;
                            if (msg.deleted && msg.movedToTrash) return;
                            if (!msg.seenBy) return;
                            if (msg.senderId !== uid && !msg.seenBy[uid]) {
                                groupUnread++;
                            }
                        });


                    });
                }
                setUnreadCount(privateUnread + groupUnread);
            });

        };

        init();

        return () => {
            if (privateRef) off(privateRef);
            if (groupRef) off(groupRef);
        };
    }, [currentUser]);

    return unreadCount;
};



export default useUnreadMessages;